import { menuData } from '@/data/menu';
import styles from './MenuPage.module.css';

function MenuPage() {
  const { categories, sides } = menuData;

  return (
    <div className={styles.page}>
      {Object.entries(categories).map(([categoryName, category]) => {
        if (categoryName === 'drafts' || category.items.length === 0) return null;

        return (
          <section key={categoryName} className={styles.category}>
            <h2 className={styles.categoryTitle}>{categoryName}</h2>
            {category.description && (
              <p className={styles.categoryDescription}>{category.description}</p>
            )}
            <div className={styles.itemsGrid}>
              {category.items.map((item) => (
                <div key={item.name} className={styles.menuItem}>
                  <table className={styles.itemTable}>
                    <tbody>
                      <tr>
                        <td className={styles.itemName}>{item.name}</td>
                        <td className={styles.itemPrice}>
                          {item.price > 0 ? `${item.price.toFixed(2)}` : ''}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {item.description && (
                    <p className={styles.itemDescription}>{item.description}</p>
                  )}
                </div>
              ))}
            </div>
          </section>
        );
      })}

      <section className={styles.sidesSection}>
        <h2 className={styles.categoryTitle}>Sides</h2>
        <div className={styles.sidesList}>
          {sides.map((side) => (
            <span key={side} className={styles.sideItem}>{side}</span>
          ))}
        </div>
      </section>
    </div>
  );
}

export default MenuPage;
